import { Redirect } from '@arpeggi/shared'
import { Box, Icons, styled } from '@arpeggi/ui'
import { FC } from 'react'
import { DeleteRedirectButton } from './DeleteRedirectButton'
import { RedirectAnchor } from './RedirectAnchor'

const StyledRowContainer = styled(Box, {
  flexGrow: 1,
  overflow: 'hidden',
  marginBottom: '16px'
})

const DeleteButtonContainer = styled(Box, { flexShrink: 0 })

const MainContentContainer = styled(Box, { gap: '8px', flexGrow: 1, overflow: 'hidden' })

interface Props {
  redirect: Redirect
}

export const RedirectRow: FC<Props> = ({ redirect }) => {
  return (
    <StyledRowContainer row justifyBetween alignCenter>
      <MainContentContainer row alignCenter>
        <RedirectAnchor link={redirect.from} />
        <Icons.ChevronRight />
        <RedirectAnchor link={redirect.to} />
      </MainContentContainer>
      <DeleteButtonContainer>
        <DeleteRedirectButton redirectId={redirect.id} />
      </DeleteButtonContainer>
    </StyledRowContainer>
  )
}
